// extracted by mini-css-extract-plugin
export default {"card-address":"CardAddress_card-address__i6v8j","card-address__content":"CardAddress_card-address__content__+MaVd","card-address__pin":"CardAddress_card-address__pin__XEONK"};